'use strict';
angular
  .module('metabuyer')
  .directive('resendPo',function($uibModal) {
    return{
      restrict: 'A',
      scope: true,
      link: function(scope) {

        var panel = function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'components/resendPO/resendPOTemplate.html',
            backdrop: 'static',
            keyboard: false,
            controller: 'ResendPOCtrl',
            scope: scope
          });
        };

        //loading the panel to comment
        scope.showResendPO = function () {
          panel();
        };
      }
    };
  });
